<template>
  <div>
    <md-empty-state
      v-if="userDetails.paid"
      class="md-primary" md-icon="thumb_up"
      :md-label="$t('nothing_to_be_done')"
      :md-description="$t('payment_sent')">
      <button @click="questionnaire_url" class="btn-rounded btn btn-info btn-sm ripple-parent">{{$t('continue_to_questionnaire')}}</button>
    </md-empty-state>
    <form novalidate class="md-layout" @submit.prevent="submitFormToConfirmPayment" v-else>
      <md-card class="md-layout-item md-size-60 md-small-size-100 mx-auto">
        <md-card-header>
          <div class="alert alert-danger fade show" role="alert" v-if="stripeError">{{stripeError}}</div>
          <div class="alert alert-success fade show" role="alert" v-if="successMessage">{{successMessage}}</div>
          <h3 class="mb-4 mt-4 font-weight-bold text-uppercase"><strong>{{$t('pay')}}</strong> <strong class="deep-blue-text font-weight-bold">{{$t('payment')}}</strong></h3>
        </md-card-header>
        <md-card-content class="ml-4 mr-4">
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClass('holder_name')">
                <md-icon>account_circle</md-icon>
                <label for="holder_name">{{$t('card.full_name')}}</label>
                <md-input type="text" name="holder_name" id="holder_name" v-model="form.holder_name" :disabled="sending" />
                <span class="md-error" v-if="!$v.form.holder_name.required">{{$t('required.fullname')}}</span>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClass('holder_email')">
                <md-icon>email</md-icon>
                <label for="email">{{$t('card.email')}}</label>
                <md-input type="email" name="holder_email" id="holder_email" autocomplete="email" v-model="form.holder_email" :disabled="sending" />
                <span class="md-error" v-if="!$v.form.holder_email.required">{{$t('required.email')}}</span>
                <span class="md-error" v-else-if="!$v.form.holder_email.email ">{{$t('invalid.email')}}</span>
              </md-field>
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClass('address_line1')">
                <md-icon>location_on</md-icon>
                <label for="address_line1">{{$t('card.address')}}</label>
                <md-input name="address_line1" id="address_line1" autocomplete="address_line1" v-model="form.address_line1" :disabled="sending" />
                <span class="md-error" v-if="!$v.form.address_line1.required">{{$t('required.address')}}</span>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClass('address_city')">
                <md-icon>location_city</md-icon>
                <label for="address_city">{{$t('card.city')}}</label>
                <md-input name="address_city" id="address_city" autocomplete="address_city" v-model="form.address_city" :disabled="sending" />
                <span class="md-error" v-if="!$v.form.address_city.required">{{$t('required.city')}}</span>
              </md-field>
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClass('address_country')">
                <md-icon>flag</md-icon>
                <label for="address_country">{{$t('card.country')}}</label>
                <md-select name="address_country" id="address_country" v-model="form.address_country" md-dense :disabled="sending">
                  <md-option v-for="(country, index) in arr_country" :key="index" :value="index">{{country}}</md-option>
                </md-select>
                <span class="md-error" v-if="!$v.form.address_country.required">{{$t('required.country')}}</span>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClass('address_zip')">
                <md-icon>dialpad</md-icon>
                <label for="address_zip">{{$t('card.zip')}}</label>
                <md-input name="address_zip" id="address_zip" autocomplete="address_zip" v-model="form.address_zip" :disabled="sending" />
                <span class="md-error" v-if="!$v.form.address_zip.required">{{$t('required.zip')}}</span>
              </md-field>
            </div>
          </div>
          <div class="card-details">
            <div class="rows">
              <i style="margin: auto 12px auto 0;" class="md-icon md-icon-font md-theme-default">credit_card</i>
              <div class="field">
                <div id="card-number" class="input empty"></div>
                <label for="card-number">{{$t('card.card_number')}}</label>
                <div class="baseline"></div>
              </div>
            </div>
            <div class="rows mobile-flex-column">
              <div class="column pr-20">
                <i style="margin: auto 12px auto 0;" class="md-icon md-icon-font md-theme-default">date_range</i>
                <div class="field">
                  <div id="card-expiry" class="input empty"></div>
                  <label for="card-expiry">{{$t('card.expiration')}}</label>
                  <div class="baseline"></div>
                </div>
              </div>
              <div class="column pl-20">
                <i style="margin: auto 12px auto 0;" class="md-icon md-icon-font md-theme-default">money</i>
                <div class="field">
                  <div id="card-cvc" class="input empty"></div>
                  <label for="card-cvc">{{$t('card.cvc')}}</label>
                  <div class="baseline"></div>
                </div>
              </div>
            </div>
          </div>
        </md-card-content>
        <div class="loading-spinner-wrap" v-if="loading">
            <md-progress-spinner :md-stroke="4" md-mode="indeterminate"></md-progress-spinner>
        </div>
        <div class="mt-0 mr-4 ml-4 mb-4">
          <div class="text-center mb-3">
              <btn :disabled="sending" type="submit" color="info" size="lg" class="btn-rounded font-weight-bold">{{$t('pay_btn')}} € {{userDetails.totalBill}}</btn>
          </div>
        </div>
      </md-card>
    </form>
  </div>
</template>

<script>
import axios from 'axios'
import { BASE_API } from '../helpers/base'
import { Btn } from 'mdbvue'
import { validationMixin } from 'vuelidate'
import { required, email, minLength, maxLength } from 'vuelidate/lib/validators'
import { getLoggedUser, initPayment, confirmPayment, isTalentApp, getBillTalent, getBillColor, willPayColorAndTalent, isVenteApp } from '../services/User.service'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Payment',
  mixins: [validationMixin],
  data(){
    return {
      card: {
        cvc: '',
        number: '',
        expiry: ''
      },
      form: {
        holder_name: null,
        holder_email: null,
        address_line1: null,
        address_city: null,
        address_country: null,
        address_zip: null
      },
      userDetails: {
        totalBill: 0,
        paid: false,
        typePayment: 'C'
      },
      siteOrigin : null,
      StripeData: {
        payment_id: '',
        client_secret: '',
        payment_status: '',
      },
      //elements
      cardNumber: '',
      cardExpiry: '',
      cardCvc: '',
      stripe: null,
      //errors
      stripeError: '',
      cardCvcError: '',
      cardExpiryError: '',
      cardNumberError: '',
      loading: false,
      sending: false,
      arr_country: [],
      successMessage: ''
    }
  },
  validations: {
    form: {
      holder_name: {
        required
      },
      holder_email: {
        required,
        email
      },
      address_line1: {
        required
      },
      address_city: {
        required
      },
      address_country: {
        required
      },
      address_zip: {
        required
      }
    }
  },
  components: {
    Btn
  },
  methods: {
    ...mapActions(['setUserDetails']),
    setUpStripe() {
        this.siteOrigin = isTalentApp() ? 'talent' : null
        this.siteOrigin = isVenteApp() ? 'vente' : this.siteOrigin
        //const stripe = Stripe('pk_live_tdDDwFPENXWmPXShzUfG9CgO');
        const stripe = Stripe(process.env.STRIPE_KEY);
        this.stripe = stripe;

        const elements = stripe.elements({
          locale: 'auto',
        });

        const inputs = document.querySelectorAll('.card-details .input');
        Array.prototype.forEach.call(inputs, function(input) {
          input.addEventListener('focus', function() {
            input.classList.add('focused');
          });
          input.addEventListener('blur', function() {
            input.classList.remove('focused');
          });
          input.addEventListener('keyup', function() {
            if (input.value.length === 0) {
              input.classList.add('empty');
            } else {
              input.classList.remove('empty');
            }
          });
        });

        const elementStyles = {
          base: {
            color: '#32325D',
            fontWeight: 500,
            fontSize: '16px',
            fontSmoothing: 'antialiased',
            '::placeholder': {
              color: '#CFD7DF',
            },
            ':-webkit-autofill': {
              color: '#e39f48',
            },
          },
          invalid: {
            color: '#FF1744',
            '::placeholder': {
              color: '#FF1744',
            },
          },
        };

        const elementClasses = {
          focus: 'focused',
          empty: 'empty',
          invalid: 'invalid',
        };

        this.cardCvc = elements.create('cardCvc', {
          style: elementStyles,
          classes: elementClasses,
        });

        this.cardExpiry = elements.create('cardExpiry', {
          style: elementStyles,
          classes: elementClasses,
        });

        this.cardNumber = elements.create('cardNumber', {
          style: elementStyles,
          classes: elementClasses,
        });

        this.cardNumber.mount('#card-number');
        this.cardExpiry.mount('#card-expiry');
        this.cardCvc.mount('#card-cvc');

        this.listenForErrors();
    },
    listenForErrors() {
      const vm = this;

      this.cardNumber.addEventListener('change', (event) => {
        vm.toggleError(event);
        vm.cardNumberError = ''
        vm.card.number = event.complete ? true : false
      });

      this.cardExpiry.addEventListener('change', (event) => {
        vm.toggleError(event);
        vm.cardExpiryError = ''
        vm.card.expiry = event.complete ? true : false
      });

      this.cardCvc.addEventListener('change', (event) => {
        vm.toggleError(event);
        vm.cardCvcError = ''
        vm.card.cvc = event.complete ? true : false
      });
    },
    toggleError (event) {
      const errorMessages = {
        incomplete_number: this.$t('card.incomplete_number'),
        invalid_number: this.$t('card.invalid_number'),
        incomplete_expiry: this.$t('card.incomplete_expiry'),
        invalid_expiry_year_past: this.$t('card.invalid_expiry_year_past'),
        incomplete_cvc: this.$t('card.incomplete_cvc'),
        card_declined: this.$t('card.card_declined')
      };

      if(event.error){
        this.stripeError = (errorMessages[event.error.code] != undefined ? errorMessages[event.error.code] : event.error.message);
        this.backToTop();
      } else {
        this.stripeError = '';
      }
    },
    submitFormToConfirmPayment() {
      this.clearCardErrors();
      let valid = true;

      if (this.stripeError) {
        valid = false;
      }
      this.$v.$touch()

      if (!this.$v.$invalid && valid) {
        this.confirmPayment()
      }
    },
    confirmPayment() {
      this.loading = true;
      this.sending = true;
      this.getUserData();
      this.getCountryList();

      const errorMessages = {
        incomplete_number: this.$t('card.incomplete_number'),
        invalid_number: this.$t('card.invalid_number'),
        incomplete_expiry: this.$t('card.incomplete_expiry'),
        invalid_expiry_year_past: this.$t('card.invalid_expiry_year_past'),
        incomplete_cvc: this.$t('card.incomplete_cvc')
        //card_declined: this.$t('card.card_declined')
      };

      const additionalData = {
        name: this.form.holder_name,
        email: this.form.holder_email,
        address: {
          "city": this.form.address_city,
          "country": this.form.address_country,
          "line1": this.form.address_line1,
          "postal_code": this.form.address_zip,
        }
      };

      this.stripe.confirmCardPayment(this.StripeData.client_secret,
        {payment_method: {card: this.cardNumber,billing_details:additionalData}}).then((result) => {
        this.loading = false;
        this.sending = false;
        if (result.error) {
          this.stripeError = (errorMessages[result.error.code] != undefined ? errorMessages[result.error.code] : result.error.message);
          this.backToTop();
          console.log(result.error);
        // payement success and nedd action or confirmation accepted else error
        } else if (result.paymentIntent && result.paymentIntent.status && result.paymentIntent.status != 'canceled') {
          let data = {
            userId: localStorage.getItem('userId'),
            payment_id: this.StripeData.payment_id,
            payment_status: result.paymentIntent.status,
            amount: this.userDetails.totalBill,
            typePayment: this.userDetails.typePayment,
            origin: this.siteOrigin
          }
          confirmPayment(data).then(response => {
            console.log("confirmPayment data: ", response);
            if (response.data.status_code && response.data.status_code == 200) {
              this.successMessage = this.$t('payment_sent_text_label')
              this.reset();
              this.$router.push({name:'Questionnaire'});
            } else if (response.data.status_code && response.data.status_code == 401) {
                this.successMessage = this.$t('card.stripe_payment_need_confirmation')
                this.reset();
                this.$router.push({name:'Account'});
            } else {
              this.stripeError = this.$t('card.stripe_payment_confirm_failed');
              this.backToTop();
            }
          })

        }
      })
    },
    clearElementsInputs() {
      this.$v.$reset()
      this.cardCvc.clear()
      this.cardExpiry.clear()
      this.cardNumber.clear()
      this.form.holder_name = ''
      this.form.holder_email = ''
      this.form.address_line1 = ''
      this.form.address_city = ''
      this.form.address_country = ''
      this.form.address_zip = ''
    },
    clearCardErrors() {
      this.stripeError = ''
      this.cardCvcError = ''
      this.cardExpiryError = ''
      this.cardNumberError = ''
    },
    reset() {
      this.clearElementsInputs()
      this.clearCardErrors()
    },
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    arr_pays(){
      axios.get(`${BASE_API}/countries`)
      .then(response => {
        this.arr_country = response.data.arr_pays
      })
    },
    getUserData(){
      if(localStorage.getItem('userId')) {
        const userId=localStorage.getItem('userId');
        getLoggedUser(userId).then(response => {
          const userData = response.data.user_info
          let typePayment = isTalentApp() ? 'T' : 'C'
          typePayment = willPayColorAndTalent(userData) ? 'CT' : typePayment
          typePayment = this.siteOrigin == 'vente' ? 'V' : typePayment
          this.userDetails.totalBill = this.getTotalBill(userData)
          this.userDetails.paid = this.isPaid(userData)
          this.userDetails.typePayment = typePayment
          this.form.holder_name = userData.prenom+" "+userData.nom
          this.form.holder_email = userData.email
          this.form.address_country = userData.pays
          console.log('User Details: ', userData)
          let initData = {
            userId: localStorage.getItem('userId'),
            amount: this.userDetails.totalBill,
            typePayment: this.userDetails.typePayment,
            origin: this.siteOrigin
          }
          // Initialisation payment stripe pour SCA
          initPayment(initData).then(result => {
            if (result.data.payment_id && result.data.client_secret) {
              this.StripeData.payment_id = result.data.payment_id;
              this.StripeData.client_secret = result.data.client_secret;
              localStorage.setItem('payment_id', this.StripeData.payment_id)
              localStorage.setItem('client_secret', this.StripeData.client_secret)
            } else {
              this.stripeError = this.$t('card.stripe_init_error');
              this.backToTop();
            }
            console.log("Init payment data: ", result);
            console.log("StripeData: ",  this.StripeData);
          })
        }).catch(error => {
          console.log(error.response);
        })
      }
    },
    getCountryList(){
      const obj_pays = {
        "AF" : "Afrique du sud",
        "De" : "Allemagne",
        "au" : "Autriche",
        "be" : "Belgique",
        "CA" : "Canada",
        "Esp" : "Espagne",
        "US" : "Etats Unis",
        "fr" : "France",
        "IN" : "Inde",
        "it" : "Italie",
        "Mad" : "Madagascar",
        "MAR" : "Maroc",
        "NZ" : "Nouvelle Zélande",
        "pl" : "Pologne",
        "GB" : "Royaume Uni",
        "Su" : "Suisse",
        "tn" : "Tunisie"
      };
      const obj_official_country = {
        "Afrique du sud" : "ZA",
        "Allemagne" : "DE",
        "Autriche" : "AT",
        "Belgique" : "BE",
        "Canada" : "CA",
        "Espagne" : "ES",
        "Etats Unis" : "US",
        "France" : "FR",
        "Inde" : "IN",
        "Italie" : "IT",
        "Madagascar" : "MG",
        "Maroc" : "MA",
        "Nouvelle Zélande" : "NZ",
        "Pologne" : "PL",
        "Royaume Uni" : "GB",
        "Suisse" : "CH",
        "Tunisie" : "TN"
      };
      Object.keys(obj_pays).forEach( e => {
        if(e == this.form.address_country){
          this.form.address_country = obj_official_country[obj_pays[e]];
        }
      });
    },
    questionnaire_url(){
      this.$router.push({name:'Questionnaire'});
    },
    backToTop(){
      $('html,body').stop().animate({
          scrollTop: 0
      }, 'slow', 'swing');
    },
    getTotalBill(userInfo){
      let totalAmount = 0;
      // je suis dans l'application talents
      if (isTalentApp()) {
        totalAmount = getBillTalent(userInfo)
        // je suis dans l'application couleurs
      } else {
        totalAmount = getBillColor(userInfo)
      }

      return totalAmount;
    },
    isPaid(userInfo){
      let ispaid = false

      // je suis dans l'application talents
      if (isTalentApp()) {
        ispaid = userInfo.talent_payement_date != null ? true : false
      // je suis dans l'application couleurs
      } else {
        ispaid = userInfo.paye != '' && userInfo.paye != null ? true : false
      }

      return ispaid;
    }
  },
  mounted(){
    this.setUpStripe();
    this.getUserData();
    this.arr_pays();
    console.log("Activate config: ", process.env);
  }
}
</script>

<style scoped>
.loading-spinner-wrap {
position: fixed;
width: 100%;
left: 0;
right: 0;
top: 0;
bottom: 0;
background-color: rgba(255,255,255,0.7);
z-index: 99999;
}
.loading-spinner-wrap .md-progress-spinner {
height: 100%;
justify-content: center;
align-items: center;
}
.card-details {
background-color: #fff;
}
.card-details .row {
display: -ms-flexbox;
display: flex;
margin: 0;
}
.card-details .field {
position: relative;
width: 100%;
height: 50px;
margin: 0 0 24px 0;
}
.card-details .field.half-width {
width: 40%;
}
.card-details .field.quarter-width {
width: calc(25% - 10px);
}
.card-details .baseline {
position: absolute;
width: 100%;
height: 1px;
left: 0;
bottom: 0;
background-color: rgba(0,0,0,0.54);
transition: background-color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}
.card-details label {
position: absolute;
left: 0;
bottom: -4px;
color: rgba(0,0,0,0.54);
overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap;
transform-origin: 0 50%;
cursor: text;
transition-property: color, transform;
transition-duration: 0.3s;
transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);
font-size: 16px;
}
.card-details .input {
position: absolute;
width: 100%;
left: 0;
bottom: 0;
padding-bottom: 7px;
color: #32325d;
background-color: transparent;
}
.card-details .input::-webkit-input-placeholder {
color: transparent;
transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}
.card-details .input::-moz-placeholder {
color: transparent;
transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}
.card-details .input:-ms-input-placeholder {
color: transparent;
transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}
.card-details .input.StripeElement {
opacity: 0;
transition: opacity 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
will-change: opacity;
}
.card-details .input.focused,
.card-details .input:not(.empty) {
opacity: 1;
}
.card-details .input.focused::-webkit-input-placeholder,
.card-details .input:not(.empty)::-webkit-input-placeholder {
color: rgba(0,0,0,0.54);
}
.card-details .input.focused::-moz-placeholder,
.card-details .input:not(.empty)::-moz-placeholder {
color: rgba(0,0,0,0.54);
}
.card-details .input.focused:-ms-input-placeholder,
.card-details .input:not(.empty):-ms-input-placeholder {
color: rgba(0,0,0,0.54);
}
.card-details .input.focused + label,
.card-details .input:not(.empty) + label {
color: rgba(0,0,0,0.54);
transform: scale(0.85) translateY(-25px);
cursor: default;
font-size: inherit;
bottom: -2px;
}
.card-details .input.focused + label {
color: #448aff;
}
.card-details .input.invalid + label {
color: #FF1744;
}
.card-details .input.focused + label + .baseline {
background-color: #448aff;
height: 2px;
}
.card-details .input.focused.invalid + label + .baseline {
background-color: #e25950;
height: 1px;
}
.card-details .input.invalid + label + .baseline {
background-color: #FF1744;
}
.card-details input, .card-details button {
-webkit-appearance: none;
-moz-appearance: none;
/* appearance: none; */
outline: none;
border-style: none;
}
.card-details input:-webkit-autofill {
-webkit-text-fill-color: #e39f48;
transition: background-color 100000000s;
/* -webkit-animation: 1ms void-animation-out; */
}
.card-details .StripeElement--webkit-autofill {
background: transparent !important;
}
.card-details input:active {
background-color: #448aff;
}
.card-details .rows {
display: flex;
}
.card-details .column {
display: flex;
width: 100%;
}
.card-details .pl-20 {
padding-left: 20px;
}
.card-details .pr-20 {
padding-right: 20px;
}
@media (max-width: 768px){
.mobile-flex-column {
flex-direction: column;
}
.card-details .pl-20,
.card-details .pr-20 {
padding: 0;
}
}
</style>



// WEBPACK FOOTER //
// src/components/Payment.vue